

import Vue from "vue"

import VueI18n from 'vue-i18n'
import zn from './zn'
import en from './en'
Vue.use(VueI18n)



function getParamsByURLSearchParams(url = window.location.href) {
  const params = {};
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  let match;
  while ((match = regex.exec(url))) {
    params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
  }
  return params;
}

let params = getParamsByURLSearchParams();

if(params.lang=='en'){
  localStorage.setItem('lang','EN')
}
if(params.lang=='cn'){
  localStorage.setItem('lang','CN')
}
if(!params){
  localStorage.setItem('lang','EN')
}
// if(!localStorage.getItem('lang')){
//   localStorage.setItem('lang','CN')
// }

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') === 'EN' ?  'en' : 'zn' || 'zn',   // 初始化中文
  messages: {
    "zn":zn,
    "en":en
  }
})
 
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js